<template>
	<Popup
		v-model="selfDisplay"
		title="修改客服人员"
		@confirmClick="handlePopupConfirmClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>筛选条件</span>
				<el-select v-model="condition" placeholder="请选择筛选条件">
					<el-option v-for="v in conditions" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="condition_tip"><i class="b_icon"></i>请选择一个筛选条件</template></div>
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>客服账号</span>
				<el-autocomplete
					class="b_inp"
					v-model="customer_account"
					:fetch-suggestions="queryCustomerAccount"
					placeholder="请输入客服账号"
				></el-autocomplete>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="customer_account_tip"><i class="b_icon"></i>请输入存在的客服账号</template></div>
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>角色</span>
				<el-select v-model="role" placeholder="请选择角色">
					<el-option v-for="v in roles" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="role_tip"><i class="b_icon"></i>请选择一个角色</template></div>
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>设置默认</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="isMaster">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</div>
			</div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js'
	import { mapState } from 'vuex'
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			conditions: {
				type: Array,
				default() { return []; }
			},
			roles: {
				type: Array,
				default() { return []; }
			},
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				selfDisplay: false,
				loading: false,
				
				id: '',
				conditionUserId: '',
				condition: '',
				customer_account: '',
				customer_uid: '',
				role: '',
				isMaster: 0,
				condition_tip: false,
				customer_account_tip: false,
				role_tip: false
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			/************************ @Events *******************************/
			// 点击弹出确定按钮
			handlePopupConfirmClick() {
				const that = this;
				if (!this.condition) {
					this.condition_tip = true;
					return false;
				} else {
					this.condition_tip = false;
				}
				if (!this.customer_account.trim()) {
					this.customer_account_tip = true;
					return false;
				} else {
					this.customer_account_tip = false;
				}
				if (!this.role) {
					this.role_tip = true;
					return false;
				} else {
					this.role_tip = false;
				}
				that.$confirm(
					'此操作将修改该客服人员?', 
					'提示', 
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.findCustomerInfo();
					}
				);
			},
			
			/************************ @Function *******************************/
			// 重置数据
			resetData() {
				this.queryInterval && clearTimeout(this.queryInterval);
				this.id = this.obj.id;
				this.conditionUserId = this.obj.conditionUserId;
				this.condition = this.obj.conditionId;
				this.customer_account = this.obj.account;
				this.customer_uid = '';
				this.role = this.obj.roleId;
				this.isMaster = this.obj.isMaster;
				this.condition_tip = false;
				this.customer_account_tip = false;
				this.role_tip = false;
			},
			// 实时查询客服账号
			queryCustomerAccount(queryString, cb) {
				const that = this;
				if (queryString) {
					that.queryInterval && clearTimeout(that.queryInterval);
					that.queryInterval = setTimeout(() => {
						var results = [];
						var requestData = {
							code: queryString
						};
						Api.findDoctorsByCode(requestData).then((res) => {
							if (res.data.success) {
								res.data.data.forEach(v => {
									results.push({
										value: v.ucode
									});
								});
								cb(results);
							} else {
								cb([]);
							}
						}, () => {
							cb([]);
						});
					}, 300);
				} else {
					cb([]);
				}
			},
			// 查询客服信息
			findCustomerInfo() {
				const that = this;
				that.loading = true;
				const requestData = {
					uCode: that.customer_account,
					type: 'b'
				};
				Api.findUserInfo(requestData).then((res) => {
					if (res.data.success && res.data.data) {
						that.customer_uid = res.data.data.uid;
						that.updateCustomer();
					} else {
						that.loading = false;
						that.$message.error('请输入存在的创建人账号');
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 修改客服
			updateCustomer() {
				const that = this;
				const requestData = {
					conditionUserId: that.conditionUserId,
					conditionId: that.condition,
					roleBUserId: that.id,
					roleId: that.role,
					uuserId: that.customer_uid,
					isMaster: that.isMaster
				};
				Api.updateCustomer(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.selfDisplay = false;
						that.$message.success(res.data.message);
						that.$emit('complete');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
		},
		watch: {
			display (newValue) {
				this.selfDisplay = newValue;
			},
			selfDisplay (newValue) {
				this.$emit("changeDisplay", newValue);
				if (newValue) {
					this.resetData();
				}
			}
		}
	}
</script>

<style>
</style>
